module.exports = __webpack_public_path__ + "img/newBen-icon-ticket.f805be0d.svg";